export type ValidatorObject = {
  name: string;
  rule?: Object;
  validate: (...args: any) => boolean;
};
export type Validator = (ruleValue: any) => string | undefined;

export type ValidationError = {
  [key: string]: Validator;
};

/**
 * ValueObjectを検証する
 *
 * @param validators
 * @param value - ValuObjectの値
 */
export function validate<V>(validators?: Validator[], value?: V): any[] | null {
  let errors: any[] = [];
  const isValid = (validators || []).every((validator) => {
    const ret = validator(value);
    if (ret) {
      errors = [...errors, ret];
    }
    return !ret;
  });
  return isValid ? null : errors;
}

/**
 * create Field level validator
 *
 * @param validator - validator
 * @param msg - error message
 */
export function createFieldValidator(
  validator: (...values: any) => boolean,
  msg: string,
) {
  return (...values: any) => (validator(...values) ? undefined : msg);
}

/**
 * override error message
 *
 * @param msg - message
 */
export function injectMessage(msg: string) {
  return (fieldValidator: (...args: any) => any) => {
    return (...a: any) => fieldValidator(...a) && msg;
  };
}
